import dxProductsRo from "@dexterLang/ro/dx_products";
import dxProductFeaturesRo from "@dexterLang/ro/dx_product_features";

export default {
    en: {},
    ro: {
        'dx_products': dxProductsRo,
        'dx_product_features': dxProductFeaturesRo,
    }
}
